//@ts-nocheck
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/buttons/jha-button/jha-button.js";
import "@banno/jha-wc/src/forms/jha-form-text-input/jha-form-text-input";
import "@banno/jha-wc/src/forms/jha-form-input-base/jha-form-input";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import "@banno/jha-wc/src/jha-avatar/jha-avatar";
import "@banno/jha-wc/src/forms/jha-form-row/jha-form-row";
import "@banno/jha-wc/src/icons/jha-icon-show";
import formElementMixin from "@banno/jha-wc/src/js/mixins/form-element-mixin";
import { Apis } from "../../utils/api-constants";
import { GlobalVariables } from "../../utils/constants";
import { routerConfig } from "../../routers";
import Router from "@jack-henry/web-component-router";
import Cookies from "js-cookie";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { resolveAuthFlowErrorMessage } from "../../utils/user-account-login-lock";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { getRequest, postRequest } from "../../utils/jha-fetch";
import "../../Components/Loader";
import { AppRouters } from "../../utils/app-router";
import { encryptValue } from "../../utils/app-utils";
import { storeOidcLoginStateFromAuthUrl } from "../../utils/oidc-login-state";
import "../Login/MultifactorAuth";

@customElement("login-page")
export class LoginPage extends formElementMixin(LitElement) {
  constructor() {
    super();
  }
  userData = {};

  static get styles() {
    return [
      css`
        jha-card {
          width: 508px;
          padding: 48px;
          position: relative;
          border-radius: 23px;
        }
        .jha-logo {
          width: 112px;
          height: 112px;
        }
        #loginBg {
          background-color: #06185f;
          display: flex;
          align-items: center;
          height: 100vh;
          width: 100vw;
        }
        jha-button {
          width: 100%;
        }
        #avatarDiv {
          display: flex;
          justify-content: center;
          width: 100%;
        }
        #submitBtn {
          width: 90px;
        }
        .sso-label {
          font-weight: 600;
        }
        .password-container {
          position: relative;
        }
        .password-toggle {
          position: absolute;
          right: 12px;
          top: 34px;
          cursor: pointer;
          z-index: 10;
          color: #666;
          padding: 4px;
          user-select: none;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .password-toggle:hover {
          color: #4157ad;
        }
        .password-toggle jha-icon-show {
          width: 20px;
          height: 20px;
        }
      `,
    ];
  }
  @property({ type: Object })
  formData = {
    userId: "",
    password: "",
    session: "",
  };
  @property()
  newUser = false;
  passConf = false;
  @property({ type: Boolean })
  apiLoading = false;
  @property({ type: Boolean })
  authCheck = true;
  @property({ type: Boolean })
  showPassword = false;
  private async onLoginClick(_e: Event) {
    this.apiLoading = true;
    const headers = {
      Authorization:
        "Basic " +
        btoa(this.formData.userId.trim() + ":" + this.formData.password),
      "X-Frame-Options": "sameorigin",
      "Content-Security-Policy": "self",
    };
    const response = await getRequest(Apis.SIGN_IN, null, headers);
    if (response?.messageStatus === null) {
      this.apiLoading = false;
      Cookies.set("userId", encryptValue(this.formData.userId), {
        secure: true,
      });
      this.formData.session = response.authChallenge.session;
      this.authCheck = false;
    } else if (response.details.length > 0) {
      this.apiLoading = false;
      const errMsg = resolveAuthFlowErrorMessage(response.details, getErrorMessage);
      showToast({
        message: errMsg,
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    } else {
      this.apiLoading = false;
      showToast({
        message: "Something went wrong, please try again.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    }
  }

  onKeyPress(e: Event) {
    if (e.type === "keypress") {
      const k = e as KeyboardEvent;
      if (k.key === "Enter") {
        this.onLoginClick(e);
      }
    }
  }

  onForgotPasswordClick() {
    const router = new Router(routerConfig);
    router.go("/reset-password");
  }
  onAuthCancelClick(e) {
    this.authCheck = e.detail;
  }

  onPasswordIconClick() {
    this.showPassword = !this.showPassword;
  }

  async onJHIDLoginClick(e: Event) {
    const authData = await getRequest(Apis.GET_AUTHURL);
    if (authData?.messageStatus === null && authData.authURL) {
      if (!storeOidcLoginStateFromAuthUrl(authData.authURL)) {
        showToast({
          message: "Something went wrong, please try again.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
        return;
      }
      e.preventDefault();
      window.location.href = authData.authURL;
    } else {
      showToast({
        message: "Something went wrong, please try again.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
    }
  }
  async connectedCallback() {
    super.connectedCallback();
    const idpErrorMessage = sessionStorage.getItem("idpErrorMessage");
    if (idpErrorMessage) {
      showToast({
        message: idpErrorMessage,
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
      sessionStorage.removeItem("idpErrorMessage");
    }
  }
  render() {
    return html`${this.apiLoading
? html`<circle-loader></circle-loader>`
: undefined}
${this.authCheck
  ? html`
<div id="loginBg">
  <jha-card>
    <form>
      <div id="avatarDiv">
        <img class="jha-logo" src="/jha-logo.png" alt="JHA" />
      </div>
      <jha-form-row>
        <div id="avatarDiv">
          <h2>Login</h2>
        </div>
      </jha-form-row>
      <jha-form-row>
        <jha-button large type="submit" @click=${this.onJHIDLoginClick} sync><span class="sso-label">Sign in with JHID</span></jha-button>
      </jha-form-row>
    </form>
  </jha-card>
</div>
`
  : html`
<multi-factor-auth .loginFormData=${this.formData} @authCancelClick=${this.onAuthCancelClick}
  .onLoginClick=${this.onLoginClick.bind(this)} />`}`;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "login-page": LoginPage;
  }
}
